export default "__VITE_ASSET__DEOoHQOw__"